<template>
  <div class="main-content clear">
    <div class="header">
      <div class="name">{{report.homework_name}}</div>
      <div class="point" v-if="report.status==3">{{report.point}}</div>
      <div class="info">
        <img class="avatar" :src="report.avatar" />
        <div>
          <div class="name-wrap">
            <span class="stu-name">{{report.nickname}}</span>
            <span class="mobile">{{report.mobile}}</span>
          </div>
          <div class="course-name">{{report.course}}</div>
          <div class="count-wrap">
            <span>本次应交：</span>
            <span class="count">{{report.objective_sum}}</span>
            <span>道客观题、</span>
            <span class="count">{{report.subjective_sum}}</span>
            <span>道主观题</span>
            <span class="real">本次实交：</span>
            <span class="count">{{report.submit_objective_num}}</span>
            <span>道客观题、</span>
            <span class="count">{{report.submit_subjective_num}}</span>
            <span>道主观题</span>
            <span class="real">总分：</span>
            <span class="count">{{report.score}}</span>
            <span>通过分数：</span>
            <span class="count">{{report.pass_score}}</span>
          </div>
        </div>
      </div>
      <div class="progress-wrapper">
        <div class="progress" v-if="report.objectiveRate !== undefined">
          <el-progress
            type="circle"
            :percentage="report.objectiveRate"
            :stroke-width="10"
            :width="80"
            :show-text="false"
          ></el-progress>
          <p class="text">
            <span>客观题</span>
            <span>得分</span>
            <span class="score">{{report.objective_score}}</span>
          </p>
        </div>
        <div class="progress" v-if="report.subjectiveRate !== undefined">
          <el-progress
            type="circle"
            :percentage="report.subjectiveRate"
            :stroke-width="10"
            :width="80"
            :show-text="false"
          ></el-progress>
          <p class="text">
            <span>简答题</span>
            <span>得分</span>
            <span class="score">{{report.subjective_score}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="left" :style="{width:leftWidth+'px'}">
        <slot name="left"></slot>
      </div>
      <div
        class="right"
        :style="{position:fixed?'fixed':'static',right:fixedRight+'px',top:'97px'}"
      >
        <div class="remark">
          <div class="title">评语</div>
          <div class="content">{{report.remark?report.remark:'待讲师批改后显示总评'}}</div>
        </div>
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomeworkApproveDetail",
  props: {
    report: {
      type: Object
    }
  },
  data() {
    return {
      reportId: this.$route.query.report_id,
      fixed: false,
      fixedRight: 0,
      leftWidth: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      let $ = window.$;
      $(".v-view").scroll(() => {
        this.setFixed();
      });
      $(window).resize(() => {
        this.setFixed();
        this.leftWidth = $(window).width() - 173 - 20 - 48 - 355 - 24 - 17;
      });
      this.leftWidth = $(window).width() - 173 - 20 - 48 - 355 - 24 - 17;
    });
  },
  methods: {
    setFixed() {
      let $ = window.$;
      if ($(".v-view").scrollTop() > 305) {
        this.fixed = true;
        this.fixedRight = 50;
        if (this.fixedRight < 0) {
          this.fixedRight = 0;
        }
      } else {
        this.fixed = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.main-content {
  background-color: #f0f2f5;
  padding: 24px;
  .header {
    background-color: white;
    padding: 32px 24px;
    padding-bottom: 35px;
    position: relative;
    margin-bottom: 30px;
    .name {
      text-align: center;
      font-size: 20px;
      font-family: PingFang SC;
      margin-bottom: 24px;
      font-weight: 500;
    }
    .point {
      width: 80px;
      height: 55px;
      box-sizing: border-box;
      text-align: right;
      padding-right: 15px;
      position: absolute;
      color: red;
      font-size: 40px;
      line-height: 32px;
      top: 15px;
      right: 47px;
      background-image: url("~@/assets/images/homework/score-line.png");
      background-repeat: no-repeat;
      background-position: right bottom;
    }
    .info {
      height: 121px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 10px;
      padding: 24px 20px;
      box-sizing: border-box;
      display: flex;
      position: relative;
      .avatar {
        width: 73px;
        height: 73px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .name-wrap {
        line-height: 19px;
      }
      .stu-name {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 400;
        color: black;
        margin-right: 13px;
      }
      .mobile {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
      }
      .course-name {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        padding: 14px 0;
        line-height: 13px;
      }
      .count-wrap {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        line-height: 13px;
      }
      .count {
        color: $primary-color;
        margin-right: 8px;
      }
      .real {
        margin-left: 29px;
      }
    }
    .progress-wrapper {
      position: absolute;
      top: 110px;
      right: 50px;
      .progress {
        display: inline-block;
        margin-left: 40px;
        position: relative;
        .text {
          width: 100px;
          position: absolute;
          text-align: center;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          flex-direction: column;
          font-size: 10px;
          color: #595959;
          .score {
            font-size: 12px;
            font-weight: 500;
            color: #ee1f1f;
          }
        }
      }
    }
  }
  .main {
    overflow: hidden;
    > .left {
      flex-grow: 1;
      margin-right: 24px;
      background-color: white;
      float: left;
    }
    > .right {
      width: 355px;
      float: left;
    }
  }
}
.remark {
  border: 1px solid rgba(231, 233, 233, 1);
  border-radius: 6px;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 15px;
  padding: 20px;
  .title {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    line-height: 16px;
    position: relative;
    padding-left: 11px;
    margin-bottom: 15px;
    &::before {
      position: absolute;
      content: "";
      width: 3px;
      height: 14px;
      background: $primary-color;
      border-radius: 2px;
      top: 7px;
      left: 0;
    }
  }
  .content {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    padding: 14px 18px 14px 16px;
  }
}
</style>